// @flow
import React from "react";
import loc from "i18next";
import { getClassNames } from "data/utils";

const ModalCloseButton = ({
    onClick,
    className,
    title = loc.t("common:close"),
}: {
    onClick: Function,
    className?: string,
}) => (
    <button
        type="button"
        className={getClassNames("close", className)}
        style={{ padding: "0px 0px 15px 10px" }}
        onClick={onClick}
        title={title}
        data-test="modalCloseButton"
    >
        <span aria-hidden="true">×</span>
        <span className="sr-only">{title}</span>
    </button>
);
ModalCloseButton.displayName = "ModalCloseButton";
export default ModalCloseButton;
